module.exports = __webpack_public_path__ + "static/girlkeepsakebox-7018997465fa8e960706badb5d0da1c3.png";